/* ============================================================
   HEMP LIFE - product recommendations loader (Gravity XL)

   WHY THIS FILE EXISTS: this theme has no assets/product-recommendations.js.
   The <product-recommendations> custom element is registered somewhere in
   the bundle, but nothing ever fetches, so the "You may also like" section
   rendered EMPTY on every product page - a 144px band with no heading and
   no cards. The endpoint itself works: requesting it with BOTH product_id
   and section_id returns the heading and four cards at 200.

   It does NOT redefine the custom element - that name is already taken and
   re-registering would throw. It fills any recommendations element that is
   still empty, which works whatever else is or isn't running.

   LOADING STRATEGY: an IntersectionObserver alone proved unreliable here -
   it registered but never fired, leaving the section empty. This is core
   commerce, so reliability beats laziness: fetch immediately when the
   section is anywhere near the viewport, observe when it is far below, and
   keep a failsafe timer so the section can never just stay blank.
   ============================================================ */
(function () {
  'use strict';

  var FAILSAFE_MS = 2500;

  function fill(el) {
    if (el.dataset.hlLoaded) return;
    el.dataset.hlLoaded = '1';

    var base = el.dataset.url;
    var productId = el.dataset.productId;
    var sectionId = el.dataset.sectionId;
    if (!base || !productId || !sectionId) return;

    fetch(base + '&product_id=' + productId + '&section_id=' + sectionId)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (text) {
        var holder = document.createElement('div');
        holder.innerHTML = text;
        var fresh = holder.querySelector('product-recommendations');
        if (fresh && fresh.innerHTML.trim().length) {
          el.innerHTML = fresh.innerHTML;
          el.classList.add('product-recommendations--loaded');
        }
      })
      .catch(function () {
        /* Leave the section empty rather than break the page, but allow a
           later attempt rather than latching the failure permanently. */
        delete el.dataset.hlLoaded;
      });
  }

  function watch(el) {
    if (el.dataset.hlWatched) return;
    el.dataset.hlWatched = '1';

    /* Already populated by something else? Leave it alone. */
    if (el.querySelector('.grid__item')) return;

    var near = false;
    try {
      var r = el.getBoundingClientRect();
      near = r.top < (window.innerHeight * 3);
    } catch (e) { near = true; }

    if (near || !('IntersectionObserver' in window)) {
      fill(el);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.unobserve(el);
      fill(el);
    }, { rootMargin: '0px 0px 600px 0px' });
    io.observe(el);

    /* If the observer never fires - which is exactly what happened before -
       load anyway rather than leave a dead band on the page. */
    setTimeout(function () { fill(el); }, FAILSAFE_MS);
  }

  function boot() {
    try {
      Array.prototype.forEach.call(
        document.querySelectorAll('product-recommendations'),
        watch
      );
    } catch (e) { /* no-op */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* The theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', boot);
})();